import '../../scss/components/_ambassador-details.scss';

export class AmbassadorDetails {
    constructor (target) {
      this.section = target;
    }

    async init () {
      this.loading(false);

      const { default: Swiper } = await import('swiper');
      const { Navigation } = await import('swiper/modules');

      await import('swiper/css');
      await import('swiper/css/navigation');
      await import('swiper/css/pagination');

      const config = {
        slidesPerView: 1,
        enabled: true,
        a11y: {
          slideRole: 'presentation',
          slideLabelMessage: '',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: this.section.querySelector('.swiper-button-next'),
          prevEl: this.section.querySelector('.swiper-button-prev'),
        },
        modules: [Navigation],
      };

      const slider = this.section.querySelector('.products-slider')
      const sliderElement = slider.querySelector('.swiper')

      new Swiper(sliderElement, config);
    }

    loading(isLoading = true) {
        this.section.classList.toggle('loading', isLoading);
    }
}
